/* eslint-disable react/jsx-pascal-case */
/* eslint-disable no-underscore-dangle */
import React from "react";

import "./Grid.css";

function DefaultCell(props) {
  return <div>{props?.default}</div>;
}

function Grid(props) {
  const {
    header: Header,
    employeePaySlip: EmployeePaySlip,
    rows: propsRows = [],
    columns: propColumns = [],
  } = props || {};
  return (
    <div className={`common-grid-container ${props?.className || ""}`}>
      <div className={EmployeePaySlip ? "" : "common-grid-header"}>{Header ? <Header /> : <div />}</div>
      <div className={EmployeePaySlip ? "grid-content-payslip" : "common-grid-content"}>
        {propsRows?.map((row) => {
          return (
            <div className={EmployeePaySlip ? "grid-row-payslip" : "common-grid-row"}>
              {propColumns?.map((item) => {
                const Component_ = item.component;
                if (Component_) {
                  return <Component_ row={row} />;
                }
                return <DefaultCell default={row[item.key]} />;
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Grid;
